import { Store } from 'redux'
import { Action, Dispatch } from '../types'
import { GetState } from '../types'
import { RemoteApiFetchErrorFactory } from '../remote-api/RemoteApiError'

const isPromise = (result: any) =>
  result && result.then && result.catch && typeof result.then === 'function' && typeof result.catch === 'function';

export default function thunkPromiseCatch(callback: (error: any, getState: GetState,
                                                     action: Action, dispatch: Dispatch) => void) {
  return (store: Store<any>) => (next: Dispatch) => (action: Action) => {
    const result = next(action);

    if (isPromise(result)) {
      (result as Promise<any>).catch((error: any) => {
        const whiteList = RemoteApiFetchErrorFactory.apiErrorWhiteList()
        let shouldCallback = true
        whiteList.forEach(service => {
          if (error.options && error.options.uri.includes(service) && error.errorCode && [401, 403].indexOf(error.errorCode) >= 0) {
            shouldCallback = false
          }
        })

        if (shouldCallback) callback(error, store.getState, action, store.dispatch as any)
      })
    }

    return result
  }
}
